import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {OckImport} from "../interface/ock-import";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {Uuid} from "../interface/response/uuid";
import {first, take} from "rxjs/operators";
import {OckNip} from "../interface/ock-nip";
import {AddressImportRow} from "../interface/address-import-row";
import {OckVin} from "../interface/ock-vin";

@Injectable({
  providedIn: 'root'
})
export class OckImportService {
  public readonly importListSubject: ReplaySubject<CountedAndPaginated<OckImport>>
    = new ReplaySubject<CountedAndPaginated<OckImport>>(1);
  private readonly nipImportRowListSubject: ReplaySubject<CountedAndPaginated<OckNip>>
    = new ReplaySubject<CountedAndPaginated<OckNip>>(1);
  private readonly vinImportRowListSubject: ReplaySubject<CountedAndPaginated<OckVin>>
    = new ReplaySubject<CountedAndPaginated<OckVin>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public import(formData: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/ock/method/import`, formData)
      .pipe(
        take(1)
      ) as Observable<Uuid>;
  }

  // public getImport(importId: string): Observable<AddressImport> {
  //   return this.httpClient.get(`/rest/crm/address-import/${importId}`)
  //     .pipe(first()) as Observable<AddressImport>;
  // }

  public loadImportList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/ock/import?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<OckImport>) => {
        this.importListSubject.next(result);
      });
  }

  public getNipImportRowListSubject(): ReplaySubject<CountedAndPaginated<OckNip>> {
    return this.nipImportRowListSubject;
  }

  public loadNipList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/ock/nip?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<OckNip>) => {
        this.nipImportRowListSubject.next(result);
      });
  }


  public getVinImportRowListSubject(): ReplaySubject<CountedAndPaginated<OckVin>> {
    return this.vinImportRowListSubject;
  }

  public loadVinList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/ock/vin?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<OckVin>) => {
        this.vinImportRowListSubject.next(result);
      });
  }

  public deleteVin(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/ock/vin/${uuid}`)
      .pipe(first());
  }
  public deleteNip(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/ock/nip/${uuid}`)
      .pipe(first());
  }

  public sendNip(formData: object): Observable<any> {
    return this.httpClient.post(`/rest/crm/ock/nip`, formData)
      .pipe(
        take(1)
      );
  }

  public sendVin(formData: object): Observable<any> {
    return this.httpClient.post(`/rest/crm/ock/vin`, formData)
      .pipe(
        take(1)
      );
  }

}
